import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-common/src/Services/UserClassifierRepoService/UserClassifierRepoService.ts";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.concat.js";
import { map, pipe, prop } from 'ramda';
import { forward, merge } from 'effector';
import { createGate } from 'effector-react';
import { isIOTSErrorResult, isJsendBadResultError, isJsendBadResultFail } from '@gmini/api-call-service';
import { NormalizedTree } from '@gmini/normalized-tree';
import { createChildDomain } from '@gmini/utils';
import * as smApi from '@gmini/sm-api-sdk';
import * as n from "./Node";
export function createUserClassifierRepoService(options) {
  var domain = createChildDomain(options.parentDomain, 'UserClassifierRepoService');
  var reset = domain.event('reset', {
    name: "reset",
    sid: "mkelvy"
  });
  var Gate = createGate({
    name: 'Mount',
    domain: domain
  });
  forward({
    ɔ: {
      from: Gate.close,
      to: reset
    },
    config: {
      sid: "deneio"
    }
  });
  var notification = domain.event('notification', {
    name: "notification",
    sid: "-9fegb4"
  });
  var created = notification.filter({
    fn: smApi.NotificationEvent.Create.is
  }).map(prop('payload'));
  var updated = notification.filter({
    fn: smApi.NotificationEvent.Update.is
  }).map(prop('payload'));
  var removed = notification.filter({
    fn: smApi.NotificationEvent.Remove.is
  }).map(prop('payload'));
  var badResult = merge([smApi.UserClassifierRepoFolder.create.failData, smApi.UserClassifierRepoFolder.rename.failData, smApi.UserClassifierRepoFolder.move.failData, smApi.UserClassifierRepoFolder.remove.failData, smApi.UserClassifier.create.failData, smApi.UserClassifier.copy.failData, smApi.UserClassifier.rename.failData, smApi.UserClassifier.move.failData, smApi.UserClassifier.remove.failData, smApi.UserClassifier.getMostRecent.failData, smApi.UserClassifier.renameVersion.failData, smApi.UserClassifier.removeVersionName.failData, smApi.UserClassifier.fetchNamedVersions.failData, smApi.UserClassifier.fetchVersionByDate.failData, smApi.UserClassifier.fetchVersionDates.failData, smApi.AssemblyClassifier.create.failData, smApi.AssemblyClassifier.copy.failData, smApi.AssemblyClassifier.rename.failData, smApi.AssemblyClassifier.move.failData, smApi.AssemblyClassifier.remove.failData, smApi.AssemblyClassifier.getMostRecent.failData, smApi.AssemblyClassifier.renameVersion.failData, smApi.AssemblyClassifier.removeVersionName.failData, smApi.AssemblyClassifier.fetchNamedVersions.failData, smApi.AssemblyClassifier.fetchVersionByDate.failData, smApi.AssemblyClassifier.fetchVersionDates.failData, smApi.UserClassifierRepo.fetch.failData], {
    name: "badResult",
    sid: "ptkl2q"
  });
  var fail = badResult.filter({
    fn: isJsendBadResultFail
  });
  var error = badResult.filter({
    fn: isJsendBadResultError
  });
  var IOTSError = badResult.filter({
    fn: isIOTSErrorResult
  });
  var getUserClassifierRepo = smApi.UserClassifierRepo.fetch.done.map(function (_ref) {
    var params = _ref.params,
        result = _ref.result;
    return _objectSpread(_objectSpread({}, result), {}, {
      id: params.projectUrn
    });
  });
  var getRepoOrFolder = merge([getUserClassifierRepo, smApi.UserClassifierRepoFolder.fetch.doneData, smApi.UserClassifierRepoFolder.fetchSilent.doneData], {
    name: "getRepoOrFolder",
    sid: "-lido19"
  });
  var normalizedTree = new NormalizedTree();
  normalizedTree.index$.on(getUserClassifierRepo.map(n.UserClassifierRepoNode.create), updateNode(['name', 'total', 'offset'])).on(getRepoOrFolder.map(pipe(prop('children'), filter(smApi.UserClassifier.is), map(n.UserClassifierNode.create))), updateNodes(['parentFolderId', 'parentKey', 'name'])).on(getRepoOrFolder.map(pipe(prop('children'), filter(smApi.AssemblyClassifier.is), map(n.AssemblyClassifierNode.create))), updateNodes(['parentFolderId', 'parentKey', 'name'])).on(getRepoOrFolder.map(pipe(prop('children'), filter(smApi.UserClassifierRepoFolder.is), map(n.UserClassifierRepoFolderNode.create))), updateNodes(['parentFolderId', 'parentKey', 'name', 'total'])).on(smApi.UserClassifierRepoFolder.create.doneData.map(n.UserClassifierRepoFolderNode.create), updateNode(['parentFolderId', 'parentKey', 'name', 'total'])).on(created.filter({
    fn: function fn(item) {
      return item.type === 'UserClassifierRepositoryFolder';
    }
  }).map(n.UserClassifierRepoFolderNode.create), updateNode(['parentFolderId', 'parentKey', 'name', 'total'])).on(smApi.UserClassifierRepoFolder.fetch.doneData.map(n.UserClassifierRepoFolderNode.create), updateNode(['parentFolderId', 'parentKey', 'name', 'total', 'offset'])).on(smApi.UserClassifierRepoFolder.rename.doneData.map(n.UserClassifierRepoFolderNode.create), updateNode(['name'])).on(smApi.UserClassifierRepoFolder.move.doneData.map(n.UserClassifierRepoFolderNode.create), updateNode(['parentFolderId', 'parentKey'])).on(updated.filter({
    fn: smApi.UserClassifierRepoFolder.is
  }).map(n.UserClassifierRepoFolderNode.create), updateNode(['parentFolderId', 'parentKey', 'name', 'total'])).on(smApi.UserClassifierRepoFolder.remove.doneData.map(n.UserClassifierRepoFolderNode.create), removeNode).on(removed.filter({
    fn: smApi.UserClassifierRepoFolder.is
  }).map(n.UserClassifierRepoFolderNode.create), removeNode).on(smApi.UserClassifier.create.doneData.map(n.UserClassifierNode.create), updateNode(['parentFolderId', 'parentKey', 'name'])).on(smApi.AssemblyClassifier.create.doneData.map(n.AssemblyClassifierNode.create), updateNode(['parentFolderId', 'parentKey', 'name'])).on(smApi.UserClassifier.copy.doneData.map(n.UserClassifierNode.create), updateNode(['parentFolderId', 'parentKey', 'name'])).on(smApi.AssemblyClassifier.copy.doneData.map(n.AssemblyClassifierNode.create), updateNode(['parentFolderId', 'parentKey', 'name'])).on(created.filter({
    fn: function fn(item) {
      return item.type === 'UserClassifier';
    }
  }).map(function (item) {
    return n.UserClassifierNode.create(item);
  }), updateNode(['parentFolderId', 'parentKey', 'name'])).on(smApi.UserClassifier.getMostRecent.doneData.map(n.UserClassifierNode.create), updateNode(['parentFolderId', 'parentKey', 'name', 'version'])).on(smApi.AssemblyClassifier.getMostRecent.doneData.map(n.AssemblyClassifierNode.create), updateNode(['parentFolderId', 'parentKey', 'name', 'version'])).on(smApi.UserClassifier.rename.doneData.map(n.UserClassifierNode.create), updateNode(['name', 'version'])).on(smApi.AssemblyClassifier.rename.doneData.map(n.AssemblyClassifierNode.create), updateNode(['name', 'version'])).on(smApi.UserClassifier.move.doneData.map(n.UserClassifierNode.create), updateNode(['parentFolderId', 'parentKey', 'version'])).on(smApi.AssemblyClassifier.move.doneData.map(n.AssemblyClassifierNode.create), updateNode(['parentFolderId', 'parentKey', 'version'])).on(updated.filter({
    fn: smApi.UserClassifier.is
  }).map(n.UserClassifierNode.create), updateNode(['parentFolderId', 'parentKey', 'name', 'version'])).on(updated.filter({
    fn: smApi.AssemblyClassifier.is
  }).map(n.AssemblyClassifierNode.create), updateNode(['parentFolderId', 'parentKey', 'name', 'version'])).on(smApi.UserClassifier.remove.doneData.map(n.UserClassifierNode.create), removeNode).on(smApi.AssemblyClassifier.remove.doneData.map(n.AssemblyClassifierNode.create), removeNode).on(removed.filter({
    fn: smApi.UserClassifier.is
  }).map(n.UserClassifierNode.create), removeNode).on(removed.filter({
    fn: smApi.AssemblyClassifier.is
  }).map(n.AssemblyClassifierNode.create), removeNode).reset(reset);
  return {
    Gate: Gate,
    nodes$: normalizedTree.index$,
    relations$: normalizedTree.relations$,
    notification: notification,
    badResult: badResult,
    fail: fail,
    error: error,
    IOTSError: IOTSError,
    reset: reset
  };
}

// TODO возможно пригодится
// type Mutable<T extends Readonly<Record<string | number | symbol, unknown>>> = {
//   [K in keyof T]: T[K]
// }
function filter(predicate) {
  return function (items) {
    return items.filter(predicate);
  };
}

function setNode(nodes, newNode) {
  var key = n.Node.getKey(newNode);
  var oldNode = nodes[key];

  if (newNode === oldNode) {
    return nodes;
  }

  return _objectSpread(_objectSpread({}, nodes), {}, _defineProperty({}, key, newNode));
}

export var updateNode = function updateNode() {
  var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return function (nodes, newNode) {
    var oldNode = n.Node.getByRef(nodes, newNode);

    if (!oldNode) {
      return setNode(nodes, newNode);
    }

    var changedProperties = properties.filter(function (property) {
      return oldNode[property] !== newNode[property];
    });

    if (!changedProperties.length) {
      return nodes;
    }

    return setNode(nodes, changedProperties.reduce(function (acc, property) {
      acc[property] = newNode[property];
      return acc;
    }, _objectSpread({}, oldNode)));
  };
};

var updateNodes = function updateNodes(properties) {
  return function (nodes, newNodes) {
    return newNodes.reduce(updateNode(properties), nodes);
  };
};

function removeNode(nodes, node) {
  var key = n.Node.getKey(node);

  if (!nodes[key]) {
    return nodes;
  }

  var newNodes = _objectSpread({}, nodes);

  delete newNodes[key];
  return newNodes;
}

export function getChildren(nodes, relations, ref) {
  var key = n.Node.getKey(ref);
  var childrenKeys = relations[key];

  if (!childrenKeys) {
    return [];
  }

  return childrenKeys.reduce(function (acc, key) {
    var node = nodes[key];

    if (node) {
      acc.push(node);
    }

    return acc;
  }, []);
}
export var buildClsGroupKey = function buildClsGroupKey(_ref2) {
  var classifierId = _ref2.classifierId,
      groupId = _ref2.groupId;
  return "".concat(classifierId, ":").concat(groupId);
};